import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import MUIDataTable from "mui-datatables";
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Dialog from '@material-ui/core/Dialog';
import DialogDetail from '../../components/Kugi/dialogdetail';
import { connect } from 'react-redux';
import {pushCategory} from '../../actions/general';

import IconButton from '@material-ui/core/IconButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import AddFeatureCatalog from './AddFeatureCatalog';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import {fetchCatalog } from '../../api/featurecatalog';
import {deleteFeatureCatalog } from '../../api/kugi';

class FeatureCatalog extends Component{

  constructor(props) {
    super(props);
    this.state = {
      category: [],
      open : false,
      dataUpdate: []
    }
  }

  componentWillMount(){
    console.log(localStorage.getItem('token'));
    if(localStorage.getItem('token')==null){
      console.log(localStorage.getItem('token'));
      this.props.history.push(`/login`);
    }
    fetchCatalog()
      .then(response => {
        this.props.pushCategory(response.data);

        const arr = [];
        response.data.map((e)=>{
          arr.push(["update", e.name, e.organisationName, e.versionDate, e.versionNumber,e.administrativeArea, e.city, e.country, e.deliveryPoint, e.electronicMailAddress, e.facsimile,e.featureCatalogId, e.fieldOfApplication, e.id, e.individualName,  e.postalCode, e.scope,   e.voice, e.featureCatalogCode]);

        })

        this.setState({category:arr});

      })
      .catch(error => {
        console.log(error);
      });
  }

  handleClose = () =>{
    fetchCatalog()
      .then(response => {
        this.props.pushCategory(response.data);

        const arr = [];
        response.data.map((e)=>{
          arr.push(["update", e.name, e.organisationName, e.versionDate, e.versionNumber, e.administrativeArea, e.city, e.country, e.deliveryPoint, e.electronicMailAddress, e.facsimile,e.featureCatalogId, e.fieldOfApplication, e.id, e.individualName,  e.postalCode, e.scope,   e.voice, e.featureCatalogCode]);

        })

        this.setState({category:arr});

      })
      .catch(error => {
        console.log(error);
      });
    this.setState({open:false});
  }
  handleReload = (e) => {
    console.log(e);
    fetchCatalog()
      .then(response => {
        this.props.pushCategory(response.data);

        const arr = [];
        response.data.map((e)=>{
          arr.push(["update", e.name, e.organisationName, e.versionDate, e.versionNumber, e.administrativeArea, e.city, e.country, e.deliveryPoint, e.electronicMailAddress, e.facsimile,e.featureCatalogId, e.fieldOfApplication, e.id, e.individualName,  e.postalCode, e.scope,  e.voice, e.featureCatalogCode]);

        })

        this.setState({category:arr});

      })
      .catch(error => {
        console.log(error);
      });
  }

  handleDelete = (e) => {

    let fcid = this.state.category[e.data[0].index][11].replace("@en", "");

    deleteFeatureCatalog(fcid)
      .then(response => {
        console.log("deleted");
      })
      .catch(error => {
        console.log(error);
      });
  }

  handleUpdate = (e)=>{

    this.setState({dataUpdate: e.rowData, open: true });

  }

  render(){

    const options = {
      filterType: 'checkbox',
      onRowsDelete: this.handleDelete
    };

    //const columns = ["Administratif Area", "City", "Country", "Delivery Point", "Email Address", "Facsimile", "Individual Name", "Name", "Organisasi", "Post Code", "Version Date", "Voice"];
    const columns = [
      {
        name:"Update",
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => (
           <BorderColorTwoToneIcon color="primary" onClick={event => this.handleUpdate(tableMeta)} style = {{cursor:"pointer"}}/>
         )
        }
      },
      {name:"Nama "},
      {name:"Organisasi"},
      {name:"Tanggal Versi"},
      {name:"Versi"},
      {name:"Wilayah Administratif"},
      {name:"Kota"},
      {name:"Negara"},
      {name:"Alamat"},
      {name:"Alamat Email"},
      {name:"Nomor Fax"},
      {name:"featureCatalogId",
        options: {
         display: false
        }
      },
      {name:"fieldOfApplication"},
      {name:"id",
        options: {
         display: false
        }
      },
      {name:"Nama Penanggung Jawab"},

      {name:"Kode Pos"},
      {name:"Ruang Lingkup"},

      {name: "Nomor Telepon"},
      {name: "Feature Catalog Code"}
     ];


    return (
      <AUX>
      <Dialog
        open={this.state.open}
        fullScreen
        maxWidth={""}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogTitle disableTypography style = {{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        >
        <span/>
            <IconButton onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <AddFeatureCatalog handleOpen = {this.handleClose} data = {this.state.dataUpdate} handleReload = {this.handleReload}/>
        </DialogContent>
      </Dialog>

      <section className="sections" style = {{paddingTop:"5%"}}>

        <div className="container">
        <Button variant="contained" color="primary" onClick = {()=>{this.setState({open:true, dataUpdate:[]})}}>Tambah Katalog Unsur</Button>
        <br/>
            <MUIDataTable
            data={this.state.category}
            columns={columns}
            options={options}
            />
            <div className="container">
                <div className="row justify-content-center" id="counter"/>
            </div>
        </div>
      </section>

      </AUX>
    )
  }
}

const mapStatetoProps = state => {

    return {
        category: state.category
    };
}


export default connect(mapStatetoProps, {pushCategory})(FeatureCatalog);
